import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46f67baa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "address" }
const _hoisted_3 = { class: "ws_drawer_footer" }

import { ref, watch, onMounted } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM, SUFFIX, PRODUCT_TYPE } from '@/common'
import CommonUpload from '@/components/common-upload'
import Text from '@/components/text'
import MapModal from '@/components/map-modal-drawer'
import {
  queryOrgTreeList,
  siteInfoAdd,
  siteInfoUpdate,
  querySiteInfo,
} from '@/api'
import { isEmpty } from 'lodash'
import { useAuthStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'site-form-drawer',
  props: ['visible', 'data', 'productTypeOps'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const authStore = useAuthStore()




const action = SUFFIX.TIANSHU + '/site/manage/uploadPic'

const formData = ref({
  picUrl: '',
  name: '',
  orgId: '',
  address: '',
  describe: '',
})
const rules: any = {
  name: [{ required: true, message: '请输入' }],
  orgId: [{ required: true, message: '请选择' }],
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      fetchList()
      formData.value.orgId = authStore.sysUserData?.orgId
      !isEmpty(props.data) && queryDetail()
    }
  }
)

const defaultImg = ref('')
const detailLoading = ref(false)

const queryDetail = async () => {
  const res: any = await querySiteInfo({
    siteId: props.data.id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const {
      describe,
      locationAddress,
      locationLat,
      locationLong,
      name,
      orgId,
      picUrl,
      picBaseUrl,
    } = res.data

    formData.value = {
      picUrl,
      name,
      orgId,
      describe,
      address: locationAddress,
    }

    mapData.value = {
      address: locationAddress,
      lat: locationLat,
      lng: locationLong,
    }

    picUrl && (defaultImg.value = picBaseUrl + picUrl)
  }
}

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
  defaultImg.value = ''
  mapData.value = {
    address: '',
    lng: '',
    lat: '',
  }
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const fn = isEmpty(props.data) ? siteInfoAdd : siteInfoUpdate
      const { address, lat, lng } = mapData.value
      const res: any = await fn({
        ...formData.value,
        locationAddress: address,
        locationLat: lat,
        locationLong: lng,
        id: props.data.id,
      })
      loading.value = false
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage.success(res?.msg)
        cancel()
        $emit('success')
      }
    }
  })
}

const deepFormat = (list: any, level = 0) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      value: id,
      id,
      label: name,
      children: deepFormat(children, level + 1),
      level: level + 1,
    }
  })
}

const dataSource: any = ref([])
const fetchList = async () => {
  const res: any = await queryOrgTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    dataSource.value = deepFormat([res.data])
  }
}

const mapConf = ref({
  visible: false,
})
const toShowMap = () => {
  mapConf.value.visible = true
}

const mapData: any = ref({
  address: '',
  lng: '',
  lat: '',
})

const deleteAddress = () => {
  mapData.value = {
    address: '',
    lng: '',
    lat: '',
  }
  formData.value.address = ''
}

const onMapChange = (mo: any) => {
  mapData.value = mo
  formData.value.address = mo.address
  formRef.value.validateField('address')
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_drawer, {
      "model-value": props.visible,
      title: props.data.id ? _ctx.$t('SITE.titleEdit') : _ctx.$t('SITE.titleNew'),
      size: "480px",
      "before-close": cancel
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            loading: loading.value,
            type: "primary",
            onClick: handleSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('SITE.yes')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, { onClick: cancel }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('SITE.no')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form, {
            model: formData.value,
            rules: rules,
            ref_key: "formRef",
            ref: formRef,
            "label-position": "left",
            "label-width": "96"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "picUrl",
                label: _ctx.$t('SITE.uploadPic')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CommonUpload), {
                    modelValue: formData.value.picUrl,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.picUrl) = $event)),
                    defaultImg: defaultImg.value,
                    action: action
                  }, null, 8, ["modelValue", "defaultImg"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "name",
                label: _ctx.$t('SITE.siteName')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event)),
                    maxlength: "20",
                    placeholder: _ctx.$t('SITE.siteNamePla')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "orgId",
                label: _ctx.$t('SITE.col2')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tree_select, {
                    disabled: "",
                    filterable: "",
                    "check-strictly": "",
                    "default-expand-all": "",
                    modelValue: formData.value.orgId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.orgId) = $event)),
                    placeholder: _ctx.$t('SITE.orgPla'),
                    data: dataSource.value,
                    "render-after-expand": true,
                    class: "ws_select",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "placeholder", "data"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "address",
                label: _ctx.$t('SITE.address')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(Text), {
                      class: "text-flex",
                      content: formData.value.address
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formData.value.address), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    (formData.value.address)
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 0,
                          onClick: deleteAddress,
                          class: "icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CircleCloseFilled)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      plain: "",
                      onClick: toShowMap,
                      class: "btn ws_ml5"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('SITE.addressEdit')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                prop: "describe",
                label: _ctx.$t('SITE.remark')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.describe,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.describe) = $event)),
                    maxlength: "200",
                    placeholder: _ctx.$t('SITE.remarkPla'),
                    rows: 4,
                    type: "textarea"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["model-value", "title"]),
    _createVNode(_unref(MapModal), {
      visible: mapConf.value.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((mapConf.value.visible) = $event)),
      data: mapData.value,
      onOnMapChange: onMapChange
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})